/*
 * @Author: 范向玲
 * @Date: 2022-12-08 14:05:44
 * @LastEditors: 范向玲
 * @LastEditTime: 2023-01-10 16:40:44
 * @Description: 矿业咨讯-数据管理表格配置
 * @FilePath: \src\components\DataManagement\management\tableConfig.js
*/
const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '资讯名称',
    dataIndex: 'name',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '资讯地址',
    dataIndex: 'url',
    slots: { customRender: 'url', },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '信息来源',
    dataIndex: 'source',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '时间',
    dataIndex: 'date',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    width: 220,
  },
];

export { tableConfig, };
